/*&zwnj;** 完整版事件中心（持久化+全方法） **&zwnj;*/
const STORAGE_KEY = 'event_center_v2'

class EventEmitter {
  constructor() {
    this.listeners = {}
    // this._restoreFromStorage()
    this._initDefaultEvents()
  }

  // 核心API
  on(eventName, listener) {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = new Set()
      // throw new Error(`事件"${eventName}"不存在`);
    }
    this.listeners[eventName].add(listener)
    // this._saveToStorage()
  }

  emit(eventName, ...args) {
    this.listeners[eventName]?.forEach(listener => {
      try {
        listener(...args)
      } catch (e) {
        console.warn(`事件处理出错: ${eventName}`, e)
      }
    })
  }

  off(eventName, listener) {
    if (this.listeners[eventName]) {
      this.listeners[eventName].delete(listener)
      this._cleanupEvent(eventName)
    }
  }

  removeAllListeners(eventName) {
    if (this.listeners[eventName]) {
      this.listeners[eventName].clear()
      this._cleanupEvent(eventName)
    }
  }

  offAllEvents() {
    Object.keys(this.listeners).forEach(eventName => {
      this.listeners[eventName].clear()
      this._cleanupEvent(eventName)
    })
  }

  // 私有方法
  _cleanupEvent(eventName) {
    if (this.listeners[eventName]?.size === 0) {
      delete this.listeners[eventName]
      // this._saveToStorage()
    }
  }

  _saveToStorage() {
    try {
      const data = {
        events: Object.keys(this.listeners),
        updated: Date.now()
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
    } catch (e) {
      console.warn('存储失败（可能处于隐私模式）')
    }
  }

  _restoreFromStorage() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY))
      if (saved?.events) {
        saved.events.forEach(eventName => {
          this.listeners[eventName] = new Set()
        })
      }
    } catch (e) {
      console.warn('持久化数据恢复失败')
    }
  }

  _initDefaultEvents() {
    [
      'api:un_auth', 'api:no_enough', 'lang:change','update:lang',
      'api:redirect', 'api:play_info', 'reset:battleTabKey',
      'api:pay_status', 'api:bean_detail', 'api:update','api:toarena','api:is_enough','api:nobind_SteamURL','api:qieSignUp','api:freeruSignUp','api:emailVerifyLogin','api:telegramLogin',"api:showRechargeRebateModal","api:deposit","api:freezeSkin"
    ].forEach(eventName => {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = new Set()
      }
    })
  }
}
/**
 * eventbus 用法
 * proxy.$EventBus.emit()
 * 
 * increment 增长
 * decrement 减少
 * noEnough 余额不足
 * eventbus
 * 
 * 在导航栏监听事件-upd 表示账户余额更新,增加或减少(扣费)
 * proxy.$EventBus.on()
 * 
 * 
 * 
 */
export default new EventEmitter()
